import { Package, TrendUp, FileText, UsersThree, Question, ClockCounterClockwise } from "@phosphor-icons/react";

const MENU_ITEMS = [
  { key: "inventory", label: "Inventory", icon: Package, testId: "sidebar-inventory-menu-item" },
  { key: "cart", label: "Quote", icon: FileText, testId: "sidebar-current-cart-menu-item" },
  { key: "customers", label: "Customers", icon: UsersThree, testId: "sidebar-customers-menu-item" },
  { key: "best_selling", label: "Best Selling Item", icon: TrendUp, testId: "sidebar-best-selling-menu-item" },
  { key: "bh_history", label: "BH Selling History", icon: ClockCounterClockwise, testId: "sidebar-bh-history-menu-item" },
  { key: "help", label: "Help", icon: Question, testId: "sidebar-help-menu-item" },
];

export function DashboardSidebar({ activeView, onViewChange, showBestSelling = true, showCustomers = false, showBHHistory = false, cartName, cartItemCount }) {
  const items = MENU_ITEMS.filter(
    (item) =>
      (item.key !== "best_selling" || showBestSelling) &&
      (item.key !== "customers" || showCustomers) &&
      (item.key !== "bh_history" || showBHHistory)
  );
  return (
    <aside
      className="flex w-12 shrink-0 flex-col gap-1 border-r border-zinc-300 bg-zinc-50 p-1.5 md:w-48 md:p-2"
      data-testid="dashboard-sidebar"
    >
      {items.map(({ key, label, icon: Icon, testId }) => {
        const isCart = key === "cart";
        return (
          <button
            key={key}
            type="button"
            onClick={() => onViewChange(key)}
            title={isCart ? `${label} (${cartItemCount ?? 0})` : label}
            className={`flex items-center justify-center gap-2 rounded-sm px-2 py-2 text-sm font-medium transition-colors duration-150 md:justify-start ${
              activeView === key ? "bg-blue-600 text-white" : "text-zinc-600 hover:bg-zinc-100"
            }`}
            data-testid={testId}
          >
            <Icon size={16} weight={activeView === key ? "bold" : "regular"} />
            {isCart ? (
              <span className="hidden min-w-0 items-center gap-1.5 md:flex">
                <span className="truncate" data-testid="sidebar-cart-name">{label}</span>
                <span
                  className="shrink-0 rounded-full bg-blue-100 px-1.5 py-0.5 text-[10px] font-bold text-blue-700"
                  data-testid="sidebar-cart-item-count"
                >
                  {cartItemCount ?? 0}
                </span>
              </span>
            ) : (
              <span className="hidden md:inline">{label}</span>
            )}
          </button>
        );
      })}
    </aside>
  );
}
